import { createContext, ReactNode, useContext } from "react";

type OnNavigate = (path: string) => void;

const NavigateToDocumentContext = createContext<OnNavigate | undefined>(
  undefined,
);

export function NavigateToDocumentProvider({
  onNavigate,
  children,
}: {
  onNavigate: OnNavigate | undefined;
  children: ReactNode;
}) {
  return (
    <NavigateToDocumentContext.Provider value={onNavigate}>
      {children}
    </NavigateToDocumentContext.Provider>
  );
}

export function useNavigateToDocument(): OnNavigate | undefined {
  return useContext(NavigateToDocumentContext);
}
